import 'babel-polyfill'
import Es6Promise from 'es6-promise'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/utils/flexible'
import 'default-passive-events'
import VConsole from 'vconsole'
import Vant from 'vant'
import { generateUuid } from '@/utils/getInfo'
import '@/assets/font/font.css'
import javaGet from '@/utils/javaGet'
import 'vant/lib/index.css'
import loading from './utils/loading'
if (!localStorage.getItem('deviceNo')) {
  localStorage.setItem('deviceNo', generateUuid())
}
Es6Promise.polyfill()
Vue.prototype.$javaGet = javaGet
Vue.use(Vant)
Vue.use(loading)
Vue.config.productionTip = false
const isDev = process.env.NODE_ENV === 'development'
isDev && new VConsole()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
